import { isEmail as isValidEmail } from 'validator';

const isEmail = value => (value && isValidEmail(value) ? undefined : 'Invalid email address');

export default isEmail;
